export const ERROR_CODE_MESSAGE = {
  BANNED_USER: 'SPACE_GATEWAY_092'
}
